import type { FuelEconomyPayload, FuelSavingBaggage, TradeWorkingInputField, TradeWorkingInputs, VehicleTab } from '../types';
import {
    FUEL_SAVING_APPLY,
    FUEL_SAVING_APPLY_AND_PRINT,
    FUEL_SAVING_CANCEL,
    FUEL_SAVING_OPEN,
    FUEL_SAVING_RESET,
    FUEL_SAVING_UPDATE_INPUT,
    SET_VEHICLE_TABS,
    SET_SCENARIO_LOAD_SETTLED
} from './actions';

export const updateInput = <Field extends TradeWorkingInputField>(
    vehicleVin: string,
    tradeVin: string,
    field: Field,
    value: TradeWorkingInputs[Field]
) => ({
    type: FUEL_SAVING_UPDATE_INPUT,
    payload: {
        vehicleVin,
        tradeVin,
        field,
        value
    }
});

export const resetFuelSaving = () => ({
    type: FUEL_SAVING_RESET
});

export const applyFuelSaving = (baggage: FuelSavingBaggage, fuelEconomy: FuelEconomyPayload) => ({
    type: FUEL_SAVING_APPLY,
    payload: {
        baggage,
        fuelEconomy
    }
});

export const applyAndPrintFuelSaving = (baggage: FuelSavingBaggage, fuelEconomy: FuelEconomyPayload) => ({
    type: FUEL_SAVING_APPLY_AND_PRINT,
    payload: {
        baggage,
        fuelEconomy
    }
});

export const cancelFuelSaving = () => ({
    type: FUEL_SAVING_CANCEL
});

export const openFuelSaving = () => ({
    type: FUEL_SAVING_OPEN
});

export const setVehicleTabs = (vehicleTabs: VehicleTab[]) => ({
    type: SET_VEHICLE_TABS,
    payload: vehicleTabs
});

export const setScenarioLoadSettled = (settled: boolean) => ({
    type: SET_SCENARIO_LOAD_SETTLED,
    payload: settled
});
